import React, { RefObject } from 'react'
import {
  PersonIcon,
  InvitePeopleFieldWrapper,
  InvitePeopleInputWrapper,
  InvitePeopleInputCombobox,
  InvitePeopleIconWrapper,
  InvitePeopleInput,
  AutocompleteList,
  AutocompleteItem,
  AutocompleteItemAvatar,
  AutocompleteItemContent,
  AutocompleteItemText,
  PrimaryText,
  SecondaryText,
} from './InvitePeople.styles'
import Spinner from 'components/Spinner'
import { useAutocomplete } from './useAutocomplete'

/**
 * Types
 */
interface InvitePeopleFieldProps {
  invitationInputRef: RefObject<HTMLInputElement>
  shareIdentifier: string
}

/**
 * Component
 */
const InvitePeopleField = ({
  invitationInputRef,
  shareIdentifier,
}: InvitePeopleFieldProps) => {
  const {
    loading,
    items,
    formik: { handleBlur },
    combobox: {
      getComboboxProps,
      getInputProps,
      getMenuProps,
      isOpen,
      highlightedIndex,
      getItemProps,
    },
    isValueSelected,
  } = useAutocomplete({
    shareIdentifier,
  })

  return (
    <InvitePeopleFieldWrapper>
      <InvitePeopleInputWrapper>
        <InvitePeopleIconWrapper>
          {loading ? <Spinner size="1em" primary /> : <PersonIcon />}
        </InvitePeopleIconWrapper>
        <InvitePeopleInputCombobox
          {...getComboboxProps()}
          className={isValueSelected ? 'value-selected' : ''}>
          <InvitePeopleInput
            // Note: don't use `onChange` and `values` props here (from Formik),
            // it breaks the Downshift behavior, `useAutocomplete` already
            // keeps in sync Downshift and Formik
            {...getInputProps({
              onBlur: handleBlur,
              ref: invitationInputRef,
              placeholder: 'Add person or email address',
              autoComplete: 'off',
              type: 'text',
              name: 'invitation',
            })}
          />
        </InvitePeopleInputCombobox>
      </InvitePeopleInputWrapper>
      <AutocompleteList data-testid="autocomplete-member" {...getMenuProps()}>
        {isOpen &&
          items.map((item, index) => (
            <AutocompleteItem
              key={item.identifier}
              className={highlightedIndex === index ? 'active' : undefined}
              {...getItemProps({ item, index })}>
              <AutocompleteItemContent>
                <AutocompleteItemAvatar
                  src={item.avatar?.small || ''}
                  name={item?.name || ''}
                />
                <AutocompleteItemText>
                  <PrimaryText>{item.name}</PrimaryText>
                  <SecondaryText>{item.email}</SecondaryText>
                </AutocompleteItemText>
              </AutocompleteItemContent>
            </AutocompleteItem>
          ))}
      </AutocompleteList>
    </InvitePeopleFieldWrapper>
  )
}

export { InvitePeopleField }
